import { z } from "zod"

import { ProductShelfLifeUom } from "../../types"

const chemicalNameMaxLength = 50

export const TechnicalInformationSchema = z.object({
  chemicalName: z
    .string()
    .max(chemicalNameMaxLength, `Chemical Name must not exceed ${chemicalNameMaxLength} characters`)
    .optional(),
  specificGravity: z.coerce
    .number()
    .min(0, "Specific Gravity must be greater than or equal to 0")
    .max(99, "Specific Gravity must not exceed 99")
    .refine((val) => {
      const decimalPlaces = val.toString().split(".")[1]?.length || 0
      return decimalPlaces <= 5
    }, "Specific Gravity must not exceed 5 decimal places")
    .optional(),
  shelfLifeDays: z.coerce.number().min(0).optional(),
  shelfLifeUom: z.nativeEnum(ProductShelfLifeUom).optional(),
  harmonizedTariffSchedule: z
    .string()
    // eslint-disable-next-line security/detect-unsafe-regex
    .regex(/^(\d{1,10})?$/, "HTS must contain only digits")
    .max(10, "HTS must not exceed 10 digits")
    .optional(),
  usmcaClass: z.boolean().default(false).optional(),
  unNumber: z.string(),
})

export type TechnicalInformationFormData = z.infer<typeof TechnicalInformationSchema>
